import type { Resource } from '../../';
export const forms_error_phoneNumber_default: Resource = {"default":"The phone number is invalid."};
